<vectronic-card [title]="'Export Options'" [displayClose]="true" (closed)="dialogRef.close()">
  <ng-container body [formGroup]="exportOptionsForm">
    <mat-tab-group (selectedTabChange)="onSelectedTabChange($event)">
      <mat-tab label="CSV">
        <div class="card-body">
          <mat-form-field appearance="outline" disabled>
            <mat-label>CSV Separator</mat-label>
            <mat-select [formControlName]="'csvSeparator'">
              <mat-option [value]="','"> ,</mat-option>
              <mat-option [value]="';'"> ;</mat-option>
              <mat-option [value]="'&#9;'"> TAB</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="form-group" appearance="outline">
            <mat-label>Files: </mat-label>
            <mat-select [formControlName]="'isSingleFile'">
              <mat-option [value]="true"> Single File</mat-option>
              <mat-option [value]="false"> Multiple Files</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </mat-tab>
      <mat-tab label="KML"></mat-tab>
    </mat-tab-group>
    <div class="button-container">
      <button mat-button color="warn" class="button reset-button" (click)="reset()">
        <mat-icon>cancel</mat-icon>
        Reset
      </button>
      <button mat-button color="accent" class="button apply-button" (click)="apply()">
        <mat-icon>file_download</mat-icon>
        Export
      </button>
    </div>
  </ng-container>
</vectronic-card>
